import React, { useState } from "react";
import ReportTable from "../components/reportTable";
import { columnsConfig } from "./reportColumns";
import ReportFilters from "../components/reportFilter";

const SanctionedReport = () => {
    const [filters, setFilters] = useState({ from: "", to: "" });
    return (
        <>
            <ReportFilters filters={filters} setFilters={setFilters} />
            <ReportTable
                title="Sanctioned Received Report"
                endpoint="reports/sanctioned"
                columns={columnsConfig.loanSanction}
                filters={filters}
            />
            </>
    );
};

export default SanctionedReport;